import * as React from "react";
const SvgSort = props => <svg width={22} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 1h22M0 9h18M0 17h13" stroke="currentColor" strokeWidth={2} /></svg>;
export default SvgSort;